<template>
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <div class="Customer-create-page">
      <!--  credit form component -->
      <BankingForm
        ref="bankingform"
        :page="$route.params.id ? 'update' : 'create'"
        :submitted="submitted"
        v-on:FormUpdate="FormUpdate = 1"
        v-on:onSubmit="onSubmit($event)"
      ></BankingForm>
    </div>
  </div>
</template>
<script>
import BankingForm from "@/components/Form/Banking/BankingForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "CustomerCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    BankingForm,
    RecordNotFound,
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("banking/fetchBankingDetails").then(() => {
      next();
    });
  },
  methods: {
    onSubmit(ev) {
      this.submitted = true;
      var data = ev.data;
      var url = "createList";
      var text = "created";
      if (this.$route.params.id) {
        data = {
          id: this.$route.params.id,
          data: ev.data,
        };
        url = "updateList";
        text = "updated";
      }

      this.$store.dispatch("banking/" + url, data).then((response) => {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: response.data.type,
          showCloseButton: true,
        });
        if (response.status == 200) {
          this.$router.push({ name: "Banking" });
        } else {
          this.submitted = false;
        }
      });
    },
  },
  computed: {
    ...mapState({
      status_code: (state) => state.banking.status_code,
      status_message: (state) => state.banking.status_message,
      status_type: (state) => state.banking.status_type,
    }),
  },
};
</script> 

<style>
</style>